import { AirbridgeDeviceAlias, airbridgeInstance, Environment } from 'airbridge'
import { getEnv } from '@unni/platform'

import { isBrowser } from '@/utils/common'
import { User } from '@/features/member/member.type'

export { AirbridgeEvents } from 'airbridge/types/events'

let isInitialized = false
type Callback = () => void
const callbackQueue: Callback[] = []

const executeCallbacks = () => {
  while (callbackQueue.length > 0) {
    const callback = callbackQueue.shift()
    callback?.()
  }
}

export const initAirbridge = (user?: User) => {
  if (!isBrowser()) return
  if (isInitialized) return
  try {
    airbridgeInstance.initialize({
      config: {
        environment: getEnv('NEXT_PUBLIC_ENV') === 'prod' ? Environment.PROD : Environment.DEV,
      },
      userProperties: {
        userId: user?.id !== 0 ? user?.id.toString() : '',
        myHospitalDistrictId: user?.myHospitalDistrict?.id || '',
        country: user?.country || '',
        ...(user?.birthYear ? { age: new Date().getFullYear() - user.birthYear } : {}),
      },
      options: {
        utmParsing: true,
        urlQueryMapping: {
          channel: 'utm_source',
          campaign: 'utm_campaign',
          ad_group: 'utm_content',
          ad_creative: 'utm_term',
          term: 'term',
        },
        autoStartTrackingEnabled: false,
        cookieWindow: 30,
      },
    })

    isInitialized = true
    executeCallbacks()
  } catch (error) {
    console.error('[airbridge init error]', error)
    // callbackQueue 초기화
    callbackQueue.length = 0
  }
}

export const sendAirbridgeEvent: typeof airbridgeInstance.sendEvent = (...args): void => {
  if (!isBrowser()) {
    console.log('[airbridge not available in server]')
    return
  }

  if (isInitialized) {
    airbridgeInstance.sendEvent(...args)
  } else {
    callbackQueue.push(() => {
      airbridgeInstance.sendEvent(...args)
    })
  }
}

export const setAmplitudeDeviceId = (amplitudeDeviceId: string): void => {
  if (!isBrowser()) {
    console.log('[airbridge not available in server]')
    return
  }

  if (isInitialized) {
    airbridgeInstance.setDeviceAlias(AirbridgeDeviceAlias.Amplitude, amplitudeDeviceId)
  } else {
    callbackQueue.push(() => airbridgeInstance.setDeviceAlias(AirbridgeDeviceAlias.Amplitude, amplitudeDeviceId))
  }
}
